<template>
    <div>
        <Daily
            :objectives="objectives"
            @onCreatedKeyResult="onUpdateObjective"
            @onDeletedKeyResult="onUpdateObjective"
            @onDeletedObjective="onUpdateObjective"
        />
    </div>
</template>

<script>
import NewKeyResult from '@/views/okr/key-result/new'
import { Daily } from '@/views/okr/list'

export default {
    name: 'MyOKRs',
    components: {
        NewKeyResult,
        Daily,
    },
    computed: {
        objectives() {
            return this.$store.getters['getOKRs']
        },
        periods() {
            return this.$store.getters['periods']
        },
    },
    watch: {
        periods(val) {
            if (val) this.getOKRsFromAPI()
        },
    },
    methods: {
        getOKRsFromAPI() {
            this.$store.dispatch('getOKRsFromAPI')
        },
        getKRsFromAPI() {
            this.$store.dispatch('getKRsFromAPI')
        },
        onUpdateObjective() {
            this.getOKRsFromAPI()
            this.getKRsFromAPI()
        },
    },
}
</script>
